import {PageViewEventType, PageViewLoggers} from './constants'

const keySeparator = '$$'
export const eventKeyCreator = ({
    elementPosition,
    eventType,
    value,
}: {
    elementPosition: string
    eventType?: string
    value?: string
}) => {
    const keys = [elementPosition]

    eventType && keys.push(eventType)

    value && keys.push(value)

    return keys.join(keySeparator)
}

export function createPageViewTargetMap(
    args: [PageViewEventType, PageViewLoggers][],
): Map<PageViewEventType, PageViewLoggers> {
    return new Map<PageViewEventType, PageViewLoggers>(args)
}
